import { styled } from '@mui/system'
import Cancel from '@mui/icons-material/Cancel'
import { Button, Card, CardContent, Modal, Typography } from '@mui/material'

export const rowDetailModalStyleMainItem = {
  marginBottom: '1rem',
  minWidth: '98%',
}

export const RowDetailModalMainItem = styled('div')(({ theme }) => ({
  flexGrow: '1',
  flexDirection: 'column',
  display: 'flex',
  marginBottom: '1rem',
  minWidth: '98%',
  margin: '0.5rem 1%',
  [theme.breakpoints.down('sm')]: {
    minWidth: '98%',
  },
}))

export const RowDetailModalItem = styled('div')(({ theme }) => ({
  flexGrow: '1',
  flexDirection: 'column',
  display: 'flex',
  minWidth: '48%',
  margin: '0.5rem 1%',
  [theme.breakpoints.down('sm')]: {
    minWidth: '98%',
  },
}))

export const RowDetailCloseButton = styled(Cancel)(({ theme }) => ({
  position: 'absolute',
  top: '0.5rem',
  right: '0.5rem',
  transition: '0.1s all',
  cursor: 'pointer',
  '&:hover': {
    color: theme.palette.error.main,
  },
}))

export const RowDetailCard = styled(Card)(() => ({
  position: 'relative',
  overflow: 'auto',
  margin: '5%',
  maxHeight: '90vh',
  maxWidth: '56rem',
  padding: '1rem',
}))

export const RowDetailCardContent = styled(CardContent)(() => ({
  flexWrap: 'wrap',
  display: 'flex',
}))

export const RowDetailButtonGroup = styled('div')(() => ({
  justifyContent: 'space-around',
  display: 'flex',
}))

export const RowDetailButton = styled(Button)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: 'white',
  '&:hover': {
    background: theme.palette.primary.dark,
  },
}))

export const RowDetailModal = styled(Modal)(() => ({
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
}))

export const RowDetailMainItemTypography = styled(Typography)(({ theme }) => ({
  flexGrow: '1',
  flexDirection: 'column',
  display: 'flex',
  marginBottom: '1rem',
  minWidth: '98%',
  margin: '0.5rem 1%',
  [theme.breakpoints.down('sm')]: {
    minWidth: '98%',
  },
}))

export const RowDetailMainItemTypeTypography = styled(Typography)(() => ({ marginRight: '1rem' }))

export const RowDetailItemTypeTypography = styled(Typography)(() => ({ lineHeight: '1' }))

export const RowDetailItemTypography = styled(Typography)(({ theme }) => ({
  flexGrow: '1',
  flexDirection: 'column',
  display: 'flex',
  minWidth: '48%',
  margin: '0.5rem 1%',
  [theme.breakpoints.down('sm')]: {
    minWidth: '98%',
  },
}))
